import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/* eslint-disable react/jsx-no-target-blank */

/** @jsxImportSource @emotion/react */
import { sendAppLinkOnNumber } from '@vc-workspace/data-adapter';
import { Typography } from '@vc-workspace/utils-typography';
import { useState } from 'react';
import { containerStyles, contentContainer, playStoreIcon, btnStyles } from './maker-hero.module.style';
import { AmplitudeEventNames, sendAmplitudeData } from '@vc-workspace/utils-amplitude';
import { PageTypes } from '@vc-workspace/utils-constants';
import ReactPlayer from 'react-player';

var MakerHero = function MakerHero(props) {
  var _useState = useState(''),
      phone = _useState[0],
      setPhone = _useState[1];

  var _useState2 = useState(false),
      getAppLinkSuccess = _useState2[0],
      toggleAppLinkSuccess = _useState2[1];

  var _useState3 = useState(''),
      errorMessage = _useState3[0],
      setErrorMessage = _useState3[1];

  var onSendAppLink = function onSendAppLink() {
    if (!phone || phone.length !== 10) {
      setErrorMessage('Please enter a valid phone number');
      setTimeout(setErrorMessage, 5000);
    }

    sendAmplitudeData(AmplitudeEventNames.APP_LINK_REQUESTED, {
      source: PageTypes.MAKER
    });
    sendAppLinkOnNumber(phone).then(function () {
      toggleAppLinkSuccess(true);
    })["catch"](function (err) {
      var _err$response, _err$response$data;

      setErrorMessage(err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message);
      setTimeout(setErrorMessage, 5000);
    });
  };

  var onPlayStoreClick = function onPlayStoreClick() {
    window.location.href = "https://play.google.com/store/apps/details?id=com.vibecity.merchantapp&referrer=utm_source=maker_page";
    return false;
  };

  return _jsxs("div", {
    css: containerStyles,
    children: [_jsx(ReactPlayer, {
      playing: true,
      muted: true,
      loop: true,
      width: '100vw',
      height: props.context.isMobileView ? '320px' : '460px',
      controls: false,
      url: props.context.isMobileView ? "https://vibecity-provider-media-production.s3.ap-south-1.amazonaws.com/miscellaneous/maker_hero_desktop.mp4" : "https://vibecity-provider-media-production.s3.ap-south-1.amazonaws.com/miscellaneous/maker_hero_desktop.mp4"
    }), _jsx("div", {
      css: contentContainer,
      children: _jsxs("div", {
        className: "page-container",
        children: [_jsxs(Typography, {
          type: props.context.isMobileView ? "Headline_H1" : "Heading2",
          color: "white",
          className: props.context.isMobileView ? "pr-4" : "",
          bold: true,
          children: ["Sell your handmade products to", !props.context.isMobileView ? _jsx("br", {}) : null, " people who'll love them"]
        }), props.context.isMobileView ? _jsx("a", {
          target: "_blank",
          href: "https://play.google.com/store/apps/details?id=com.vibecity.merchantapp&referrer=utm_source=maker_page",
          rel: "noreferrer",
          children: _jsx("img", {
            src: "/_mp-images/play_store.png",
            css: playStoreIcon,
            onClick: onPlayStoreClick
          })
        }) : _jsx(_Fragment, {
          children: _jsx("a", {
            target: "_blank",
            href: "https://seller.vibecity.com",
            children: _jsx(Typography, {
              type: "SubHeading1",
              color: "white",
              css: btnStyles,
              inline: true,
              children: "Start Selling"
            })
          })
        })]
      })
    })]
  });
};

export default MakerHero;